import React from "react";
import { CardNotification, Text } from "@foris/avocado-suite";
import { useTranslation } from "react-i18next";
import { InstructorRemovalReason } from "@context/instructorRemovalFlow/types";
import { InstructorCorrectionValidity } from "./contextVacancies/useVacanciesStore";
import styles from "./instructorCorrectionNotice.module.scss";

interface InstructorCorrectionNoticeProps {
  leagueCode?: string;
  reasons: InstructorRemovalReason[];
  validity?: InstructorCorrectionValidity;
}

const InstructorCorrectionNotice: React.FC<InstructorCorrectionNoticeProps> = ({
  leagueCode,
  reasons,
  validity,
}) => {
  const { t } = useTranslation();
  const prefix = "bundle.instructor-correction";
  // The table's live validity wins; the removal reasons only cover the renders
  // before the table publishes it.
  const showResponsibility = validity
    ? !validity.responsibilityValid
    : reasons.includes("responsibility");
  const showMissingPrimary = validity
    ? !validity.primaryValid && validity.primaryCount < 1
    : reasons.includes("primary-missing");
  const showMultiplePrimary = validity
    ? !validity.primaryValid && validity.primaryCount > 1
    : reasons.includes("primary-multiple");

  if (!showResponsibility && !showMissingPrimary && !showMultiplePrimary) return null;

  return (
    <CardNotification
      state="warning"
      outlined
      className={styles.instructorCorrectionNotice}
      title={t(`${prefix}.notice-title`, { league: leagueCode ?? "" })}
    >
      <div className={styles.instructorCorrectionNotice_messages}>
        {showResponsibility && <Text>{t(`${prefix}.responsibility-message`)}</Text>}
        {showMissingPrimary && <Text>{t(`${prefix}.primary-missing-message`)}</Text>}
        {showMultiplePrimary && <Text>{t(`${prefix}.primary-multiple-message`)}</Text>}
      </div>
    </CardNotification>
  );
};

export default InstructorCorrectionNotice;
